<template>
  <div>
    <div class="detail-title">{{ name }}</div>
    <div id="qrCode" class="ewmcode" ref="qrCodeDiv"></div>
    <div class="detail-info">检查时，请出示此二维码。</div>
    <div class="detail-info">
      离院后如需咨询医生，请关闭此页，点击公众号左下角菜单“在线咨询”，按提示选择医生咨询
     </div>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2';
export default {
  name: 'qrcode',
  data() {
    return {
      id: this.$route.query.id,
      name: this.$route.query.name
    }
  },
  mounted() {
   this.getQrcode();
  },
  methods: {
  
    async getQrcode() {
      
      let auth =this.$createAuth(this.$md5);
      let _this = this;
      let result = await this.$http.get(this.$url.toPrintStudentCode,{
        studentId: this.id,
        auth: auth.code,
        time: auth.time
      });
      setTimeout(function(){
          new QRCode(_this.$refs.qrCodeDiv, {
            text: result.data.url,
            width: 230,
            height: 230,
            colorDark: "#333333", //二维码颜色
            colorLight: "#ffffff", //二维码背景色
            correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
        });
      },500)
    },
  }
}
</script>

<style>
.detail-title {
  margin: 0.5rem auto;
  font-size: 0.36rem;
  font-weight: bold;
}
.detail-info {
  padding: 0.1rem 0.5rem;
  text-align: left;
  font-size: 0.32rem;
  font-weight: bold;
}
.ewmcode {
  width: 230px;
  height: 230px;
  margin: 0 auto 0.5rem;
}
</style>